<template>
  <div class="review-task flex-col">
    <!-- 提交后 -->
    <div
      v-if="!!currentWayFinished"
      class="task-body way-summary-wrap flex-col"
    >
      <online-review-way-summary
        class="flex-1"
        :review-id="reviewId"
        :order-id="orderId"
        :review-way="reviewWay"
        :in-task="true"
        :reviewer="reviewer"
        :is-review-close="isReviewClose"
        :review-closed="reviewClosed"
        :offer-unit="offerUnit"
        :offer-require-tax="offerRequireTax"
      />
    </div>
    <!-- 评审中 -->
    <div v-else class="task-body flex-1 flex col-stretch">
      <!-- 投标单位列表 -->
      <div
        class="review-card bidder-list flex-column"
        :class="{ collapse: bidderListCollapse }"
      >
        <div
          v-show="bidderListCollapse"
          class="text-primary clickable m-t-8 flex-col col-center"
          @click="switchBidderListCollapse"
        >
          <span>展开</span>
          <a-icon type="menu-unfold" />
        </div>
        <div
          v-show="!bidderListCollapse"
          class="flex-column flex-1"
          style="overflow: hidden"
        >
          <div class="review-card-title flex row-between">
            <span>投标单位列表</span>
            <span
              class="text-primary clickable"
              @click="switchBidderListCollapse"
            >
              收起
              <a-icon type="menu-fold" class="m-l-4" />
            </span>
          </div>
          <online-review-bidder-list
            ref="bidderList"
            class="flex-1"
            :order-id="orderId"
            :review-id="reviewId"
            :purchase-type="purchaseType"
            :way-id="reviewWay.wayId"
            :bidder="currentBidder"
            :show-score="isScoreMethod"
            :reviewer="reviewer"
            :review-way="reviewWay"
            @changeBidder="changeBidder"
          />
        </div>
      </div>
      <!-- 评审操作 -->
      <div
        class="review-card review flex-column"
        :class="{ collapse: reviewActionCollapse }"
      >
        <div
          v-show="reviewActionCollapse"
          class="text-primary clickable m-t-8 flex-col col-center"
          @click="switchReviewActionCollapse"
        >
          <div>展开</div>
          <a-icon type="menu-unfold" />
        </div>
        <div
          v-show="!reviewActionCollapse"
          class="flex-column flex-1"
          style="overflow: hidden"
        >
          <div class="review-card-title flex row-between">
            <span>单位评审</span>
            <span
              class="text-primary clickable"
              @click="switchReviewActionCollapse"
            >
              收起
              <a-icon type="menu-fold" class="m-l-4" />
            </span>
          </div>
          <online-review-action
            ref="reviewAction"
            class="flex-1"
            :order-id="orderId"
            :review-id="reviewId"
            :purchase-type="purchaseType"
            :bidder="currentBidder"
            :review-way="reviewWay"
            :read-only="currentWayFinished"
            :reviewer="reviewer"
            :quote-review-opened="quoteReviewOpened"
            :offer-unit="offerUnit"
            :offer-require-tax="offerRequireTax"
          />
        </div>
      </div>
      <!-- 报价文件 -->
      <div class="review-card file">
        <div class="review-card-title">
          <span>投标文件</span>
          <el-dropdown
            v-if="showFileDropdown"
            trigger="click"
            class="m-l-16"
            @command="changeOfferFileType"
          >
            <span>
              {{ offerFileTypeLabel }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in offerFileTypeOption"
                :key="item.value"
                :command="item.value"
              >
                {{ item.label }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="iframe-wrap">
          <iframe
            v-if="currentOfferFileUrl"
            :src="
              `/pdfjs/web/viewer.html?file=${encodeURIComponent(
                currentOfferFileUrl
              )}&page=${1}#page=${1}`
            "
            frameborder="0"
            class="frame"
          ></iframe>
          <div v-else class="wrap-default">
            <div>暂无报价文件</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showAction" class="task-foot">
      <el-button type="primary" plain @click="saveScore">保存</el-button>
      <el-button type="primary" plain @click="saveScoreAndNext">
        保存并展示下一个
      </el-button>
      <el-button type="primary" @click="submitAllScore">
        提交全部评审记录
      </el-button>
      <el-button v-if="isQuotationReview" type="primary" @click="toOpenRound">
        {{ isInquiryReview ? '发起多轮报价' : '发起多轮响应' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { workbenchServiceDict } from '@/dictionary/system'
import OnlineReviewBidderList from '@/components/online-review/review/OnlineReviewBidderList.vue'
import OnlineReviewAction from '@/components/online-review/review/OnlineReviewAction.vue'
import OnlineReviewWaySummary from '@/components/online-review/review/OnlineReviewWaySummary.vue'

import {
  inquiryReviewTypeDict,
  onlineReviewMethodDict,
  onlineReviewScoreStatusDict
} from '@/dictionary/project/online-review'
import {
  completePurchaseReviewScoreApi,
  submitPurchaseReviewScoreApi
} from '@/api/procure/purchase-review'
import { currencyTypeDict, purchaseTypeDict } from '@/dictionary/project/common'
import { getInquiryReviewQuoteFileApi } from '@/api/procure/inquiry-review'
import { inquiryReviewFileTypeDict } from '@/dictionary/project/inquiry'

import { getNegotiationReviewQuoteFileApi } from '@/api/procure/negotiation-review'
/**
 * 线上评审任务
 */
export default {
  name: 'OnlineReviewTask',

  components: {
    OnlineReviewWaySummary,
    OnlineReviewAction,
    OnlineReviewBidderList
  },

  props: {
    reviewId: {
      type: [String, Number],
      default: ''
    },

    orderId: {
      type: [String, Number],
      default: ''
    },

    roundId: {
      type: [String, Number],
      default: ''
    },

    reviewClosed: {
      type: Boolean,
      default: false
    },

    // 当前评审办法
    reviewWay: {
      type: Object,
      default: () => {}
    },

    // 评审专家信息
    reviewer: {
      type: Object,
      default: () => {}
    },

    // 是否已提交
    submitted: {
      type: Boolean,
      default: false
    },

    offerUnit: {
      type: String,
      default: currencyTypeDict.YUAN.label
    },

    purchaseType: {
      type: [Number, String],
      default: purchaseTypeDict.INQUIRY.value
    },

    showFileDropdown: {
      type: Boolean,
      default: false
    },

    // 是否终止评审
    isReviewClose: {
      type: Boolean,
      default: false
    },

    // 是否开启打分
    quoteReviewOpened: {
      type: Boolean,
      default: false
    },

    offerRequireTax: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      purchaseTypeDict,

      // 当前正在进行评审的投标单位
      currentBidder: {},
      // 当前投标单位的报价文件
      currentOfferFileUrl: '',
      // 报价文件类型
      offerFileType: inquiryReviewFileTypeDict.OFFER_ATTACHMENT.value,

      // 控制投标单位展开与收起
      bidderListCollapse: sessionStorage.getItem('bidderListCollapse')
        ? !!+sessionStorage.getItem('bidderListCollapse')
        : false,
      //   控制单位评审展开与收起
      reviewActionCollapse: sessionStorage.getItem('reviewActionCollapse')
        ? !!+sessionStorage.getItem('reviewActionCollapse')
        : false
    }
  },

  computed: {
    // 代理机构加上Agency
    entrustRouter() {
      if (this.currentWorkbench === workbenchServiceDict.AGENCY.value) {
        return 'Agency'
      }
      return ''
    },

    // 当前评审办法已完成评审
    currentWayFinished() {
      if (this.isReviewClose) {
        return (
          this.reviewWay?.summaryStatus ===
          onlineReviewScoreStatusDict.COMPLETED.value
        )
      }
      return (
        this.reviewWay?.summaryStatus ===
          onlineReviewScoreStatusDict.COMPLETED.value ||
        this.reviewClosed ||
        this.submitted
      )
    },

    // 当前评审办法是打分型评审
    isScoreMethod() {
      return this.reviewWay?.reviewMethod === onlineReviewMethodDict.SCORE.value
    },

    // 显示底部操作
    showAction() {
      if (this.isQuotationReview && !this.quoteReviewOpened) {
        return false
      }
      return !this.submitted
    },

    // 是价格分评审
    isQuotationReview() {
      return this.reviewWay.wayType === inquiryReviewTypeDict.QUOTATION.value
    },

    // 是否是询比线上评审
    isInquiryReview() {
      return Number(this.purchaseType) === purchaseTypeDict.INQUIRY.value
    },

    // 报价文件类型选项
    offerFileTypeOption() {
      return inquiryReviewFileTypeDict.array
    },

    offerFileTypeLabel() {
      return inquiryReviewFileTypeDict.translate(this.offerFileType)?.label
    },

    getReviewQuoteFileApi() {
      const obj = {
        [purchaseTypeDict.INQUIRY.value]: getInquiryReviewQuoteFileApi,
        [purchaseTypeDict.NEGOTIATION.value]: getNegotiationReviewQuoteFileApi
      }
      return obj[this.purchaseType]
    }
  },

  methods: {
    /**
     * 切换投标单位
     */
    changeBidder(currentBidder) {
      this.currentBidder = currentBidder || {}
      this.getBidderOfferFile()
    },

    getBidderOfferFile() {
      if (!this.currentBidder.supplierId) return
      this.getReviewQuoteFileApi({
        reviewId: this.reviewId,
        orderId: this.orderId,
        supplierId: this.currentBidder.supplierId,
        fileType: this.offerFileType
      })
        .then(res => {
          this.currentOfferFileUrl = res.data || ''
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    saveScore() {
      if (this.isReviewClose) {
        this.$message.warning('该评审已终止，操作失败')
        return
      }
      return new Promise(resolve => {
        const scoreList = this.$refs.reviewAction.getBidderScore()
        const postData = {
          wayId: this.reviewWay.wayId,
          supplierId: this.currentBidder.supplierId,
          supplierName: this.currentBidder.supplierName,
          itemScoreList: scoreList.map(item => {
            return {
              wayItemId: item.wayItemId,
              score: item.score,
              remark: item.remark
            }
          })
        }
        // 如果有专家id，则添加
        const params = this.reviewer?.reviewerId
          ? { reviewerId: this.reviewer.reviewerId }
          : {}
        submitPurchaseReviewScoreApi(this.reviewId, postData, params)
          .then(res => {
            this.$message.success('提交打分成功')
            this.$refs.bidderList.getBidderList()
            resolve()
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
          })
      })
    },

    saveScoreAndNext() {
      if (this.isReviewClose) {
        this.$message.warning('该评审已终止，操作失败')
        return
      }
      this.saveScore().then(() => {
        this.$refs.bidderList.nextBidder()
      })
    },

    submitAllScore() {
      if (this.isReviewClose) {
        this.$message.warning('该评审已终止，操作失败')
        return
      }
      const allScored = this.$refs.bidderList.validateAllScored()
      if (!allScored) {
        this.$message.warning('请先完成待评列表')
        return
      }
      // 如果有专家id，则添加
      const expertParams = this.reviewer?.reviewerId
        ? { reviewerId: this.reviewer.reviewerId }
        : {}
      completePurchaseReviewScoreApi(this.reviewId, {
        wayId: this.reviewWay.wayId,
        ...expertParams
      })
        .then(res => {
          this.$emit('afterSubmitAll')
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 切换报价文件类型
     */
    changeOfferFileType(fileType) {
      this.offerFileType = fileType
      this.getBidderOfferFile()
    },

    /**
     * 发起多轮报价
     */
    toOpenRound() {
      if (this.isInquiryReview) {
        this.toOpenInquiryRound()
      } else {
        this.toOpenResponse()
      }
      this.$emit('reload')
    },

    /**
     * 跳转询比发起多轮报价页面
     */
    toOpenInquiryRound() {
      if (this.isReviewClose) {
        this.$message.warning('该评审已终止，操作失败')
        return
      }
      const params = {
        orderId: this.orderId,
        roundId: this.roundId
      }

      const route = this.$router.resolve({
        name: this.entrustRouter + 'InquiryMultipleRounds',
        params,
        query: {
          from: 'ReviewHall'
        }
      })
      window.open(route.href, '_blank')
    },

    /**
     * 跳转到谈判采购多轮响应页面
     */
    toOpenResponse() {
      if (this.isReviewClose) {
        this.$message.warning('该评审已终止，操作失败')
        return
      }
      this.$router.push({
        name: this.entrustRouter + 'NegotiationRoundNegotiate',
        params: {
          orderId: this.orderId
        },
        query: {
          from: 'ReviewHall'
        }
      })
    },

    /**
     * 切换投标单位收起和展开
     */
    switchBidderListCollapse() {
      this.bidderListCollapse = !this.bidderListCollapse
      sessionStorage.setItem(
        'bidderListCollapse',
        this.bidderListCollapse ? '1' : '0'
      )
    },

    /**
     * 切换评审办法收起和展开
     */
    switchReviewActionCollapse() {
      this.reviewActionCollapse = !this.reviewActionCollapse
      sessionStorage.setItem(
        'reviewActionCollapse',
        this.reviewActionCollapse ? '1' : '0'
      )
    }
  }
}
</script>

<style scoped lang="scss">
.review-task {
  width: 100%;
  overflow: hidden;
}

.review-card {
  height: 100%;
  border: 1px solid $info-fourth-color;
  overflow: hidden;

  .review-card-title {
    color: $text-color;
    padding: 10px 24px;
    background: $info-sixth-color;
    border-bottom: 1px solid $info-fourth-color;
    @include text-bold;
  }

  &.bidder-list {
    width: 340px;
  }

  &.review {
    width: 560px;
  }

  &.file {
    flex: 1;
    min-width: 400px;
  }

  &.collapse {
    width: 60px;
  }
}

.task-body {
  width: 100%;
  overflow: hidden;

  &.way-summary-wrap {
    height: 100%;
  }
}

.iframe-wrap {
  margin: 0 auto;
  width: 100%;
  height: calc(100% - 40px);

  .frame {
    width: 100%;
    height: 100%;
  }

  .wrap-default {
    padding-top: 24px;
    height: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    position: relative;
  }
}

.task-foot {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  background: $white-color;
  box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.06);
  border: 1px solid $info-fifth-color;
  height: 56px;
  text-align: center;
  padding: 12px 0;
}
</style>
